import * as answerQueries from './answer';
import * as authQueries from './auth';
import * as commentQueries from './comment';
import * as questionQueries from './question';
import * as topicQueries from './topic';
import * as userQueries from './user';

export default {
  answerQueries,
  authQueries,
  commentQueries,
  questionQueries,
  topicQueries,
  userQueries,
};
